export const iconFontAwesomeShoppingStoreSlash = (
	<i className="fa-solid fa-store-slash"></i>
);
